export default __webpack_public_path__ + "static/media/shoot-day.cf3cd192.webp";